import { memo } from 'react';

import { Close } from '@air/next-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';

export type SearchCommandClearButtonProps = Pick<IconButtonProps, 'onClick'>;

export const SearchCommandClearButton = memo(({ onClick }: SearchCommandClearButtonProps) => {
  return (
    <IconButton
      appearance="ghost"
      className="absolute top-2 right-2"
      color="grey"
      icon={Close}
      label="Close"
      size="small"
      onClick={onClick}
    />
  );
});

SearchCommandClearButton.displayName = 'SearchCommandClearButton';
